import React from "react";
import {Form, Radio, Switch} from "antd";
import IconPicker from "../../../../shared/IconPicker";
import ButtonTypePicker from "../../../../shared/button/ButtonTypePicker";
import ColorPicker from "../../../../shared/pickers/ColorPicker";
import TranslationInput from "../../../../shared/input/TranslationInput";
import Utils from "../../../../../utils";

interface IProps {
    defaultLabel?: string | JSX.Element
    namePath?: string[]
    labelRequired?: boolean
}

class ButtonProperties extends React.Component<IProps> {

    render() {
        const {defaultLabel, namePath, labelRequired} = this.props
        return (
            <div>
                <Form.Item name={[...namePath ?? [], 'label']} label={'Zvolte titulek'} rules={[{required: labelRequired === undefined ? true: labelRequired}]} initialValue={defaultLabel}>
                    <TranslationInput code={'configuration.widget.action.label.' + Utils.uuid()} preserveCode={true}/>
                </Form.Item>
                <Form.Item name={[...namePath ?? [], 'icon']} label={'Zvolte ikonu'}>
                    <IconPicker/>
                </Form.Item>
                <Form.Item name={[...namePath ?? [], 'danger']} label={'Vystrazne'} valuePropName={'checked'}>
                    <Switch/>
                </Form.Item>
                <Form.Item name={[...namePath ?? [], 'type']} label={'Zvolte typ tlačítka'} rules={[{required: true}]} initialValue={'primary'}>
                    <ButtonTypePicker/>
                </Form.Item>
                <Form.Item name={[...namePath ?? [], 'size']} label={'Zvolte velikost'} initialValue={'small'}>
                    <Radio.Group>
                        <Radio value={'small'}>malé</Radio>
                        <Radio value={'middle'}>střední</Radio>
                        <Radio value={'large'}>velké</Radio>
                    </Radio.Group>
                </Form.Item>
                <Form.Item name={[...namePath ?? [], 'color']} label={'Zvolte barvu'}>
                    <ColorPicker/>
                </Form.Item>
                <Form.Item name={[...namePath ?? [], 'textColor']} label={'Zvolte barvu textu'}>
                    <ColorPicker/>
                </Form.Item>
            </div>
        )
    }
}

export default ButtonProperties